import { initRouteTracking, trackWebVitals } from 'src/appInsights';
import { history } from 'src/store/configureStore';

initRouteTracking(history);

if (typeof window !== 'undefined') {
  window.addEventListener('load', function() {
    setTimeout(trackWebVitals, 3000);
  });
}
